import { Fragment } from "react/jsx-runtime";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { ModalTitle, UIKits } from "../../../Constants/Constants";
import BasicModal from "./BasicModal/BasicModal";
import CenteredModal from "./CenteredModal/CenteredModal";
import CustomModals from "./CustomModals/CustomModals";
import FullscreenModal from "./FullscreenModal/FullscreenModal";
import SizeModal from "./SizeModal/SizeModal";
import StaticModal from "./StaticModal";
import ToggleModal from "./ToggleModal/ToggleModal";

const ModalContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ModalTitle} parent={UIKits} />
      <Container fluid>
        <Row>
          <BasicModal />
          <SizeModal />
          <FullscreenModal />
          <CenteredModal />
          <ToggleModal />
          <StaticModal />
          <CustomModals />
        </Row>
      </Container>
    </Fragment>
  );
};
export default ModalContainer;
